import type { PropsWithChildren } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface TabContainerGroupProps {
  className?: string;
}

export const TabContainerGroup = ({
  className,
  children,
}: PropsWithChildren<TabContainerGroupProps>) => (
  <div className={classNames("flex flex-col gap-y-6", className)}>
    {children}
  </div>
);
